"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_ACCOUNT_SETTINGS_CONTACT = exports.COMPANY_ACCOUNT_SETTINGS_ABOUT = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
exports.COMPANY_ACCOUNT_SETTINGS_ABOUT = (0, form_1.form)({
    name: "COMPANY_ACCOUNT_SETTINGS_ABOUT",
    title: "General Company Information",
    content: [question_groups_1.QuestionGroup["COMPANY_GETTING_STARTED_PART1"]],
});
exports.COMPANY_ACCOUNT_SETTINGS_CONTACT = (0, form_1.form)({
    name: "COMPANY_ACCOUNT_SETTINGS_CONTACT",
    title: "Company Contact Information",
    content: [question_groups_1.QuestionGroup["COMPANY_GETTING_STARTED_PART2"]],
});
